module.exports = __webpack_public_path__ + "img/IMG_3728.8580c5d2.jpg";